import { IconButton, styled } from '@mui/material';

export const ButtonMoreStyled = styled(IconButton)(({ theme }) => ({
  background: theme.palette.dark.dark_4,
  opacity: '0.5',
  ':hover': {
    background: theme.palette.primary.main,
  },
}));
